export default __webpack_public_path__ + "static/media/premium.f9367b3d.svg";